import React from "react";

const Map = () => {
	return (
		<section className="map-sections p-5">
			<div className="containerr">
				<div className="map-wrapper w-full !h-[650px]">
					<iframe
						title="Trivnet Services Location"
						src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d797.7196441970466!2d7.478091481479236!3d9.08247584670378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sng!4v1743907162284!5m2!1sen!2sng"
						width="100%"
						height="100%"
						style={{ border: 0 }}
						allowFullScreen=""
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
					></iframe>

					<div className="map-overlay">
						<div className="overlay-card">
							<h3>Visit Our Office</h3>
							<div className="info-item">
								<i className="fas fa-map-marker-alt"></i>
								<p>44 Fez Street Kumasi Crescent Wuse II Abuja FCT</p>
							</div>
							<div className="info-item">
								<i className="fas fa-clock"></i>
								<p>Monday - Friday: 9:00 AM - 6:00 PM</p>
							</div>
							<a
								href="https://maps.app.goo.gl/849K8X1v5sdk9eC17"
								target="_blank"
								rel="noopener noreferrer"
								className="directions-btn"
							>
								<i className="fas fa-directions"></i> Get Directions
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Map;
